/**
 * @author Camilo
 * @since  19/11/2018
 */
export class RegistroNegocioPendienteModel{

    constructor(public negocio:string, public cantidad:number, public activarUsuario:boolean,public pendientesAprobacionContab:number){}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/GenerarInterfaz/RegistroNegocioPendiente.model.ts